import React from 'react';
import { Button } from './ui/Button';
import { Moon, Clock } from 'lucide-react';
const PRODUCT_IMAGE = 'https://cdn.magicpatterns.com/uploads/aSzFRmhQMwh8e9CwHWzxqy/producto_3_am.png';
export function HeroSection() {
  return <div className="relative overflow-hidden bg-slate-900 text-white pt-20 pb-24 sm:pt-32 sm:pb-32" data-id="element-98">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden z-0 opacity-20" data-id="element-99">
        <div className="absolute top-0 right-0 w-[500px] h-[500px] bg-indigo-500 rounded-full blur-[120px] -translate-y-1/2 translate-x-1/3" data-id="element-100"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-amber-500 rounded-full blur-[100px] translate-y-1/3 -translate-x-1/4" data-id="element-101"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6" data-id="element-102">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16" data-id="element-103">
          {/* Text content */}
          <div className="flex-1 text-center lg:text-left" data-id="element-104">
            <div className="inline-flex items-center space-x-2 bg-slate-800/50 backdrop-blur-sm px-4 py-1.5 rounded-full border border-slate-700 mb-8" data-id="element-105">
              <Moon className="w-4 h-4 text-amber-400" data-id="element-106" />
              <span className="text-sm font-medium text-slate-200" data-id="element-107">
                Para mujeres 40+ en México
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl md:text-6xl font-serif font-bold tracking-tight mb-8 leading-tight" data-id="element-108">
              Te duermes. <br data-id="element-109" />
              <span className="text-slate-400" data-id="element-110">
                Y luego... a las 3AM tu cuerpo decide que ya descansaste.
              </span>
            </h1>

            <p className="text-lg sm:text-xl text-slate-300 mb-10 leading-relaxed max-w-2xl" data-id="element-111">
              No es que estés exagerando. Es que en esta etapa, tu sueño se
              vuelve más sensible.
              <br className="hidden sm:block" data-id="element-112" />
              <strong className="text-white" data-id="element-113">3AM RESET</strong> es el sistema
              para volver a dormir cuando despiertas entre 2–4am.
            </p>

            <div className="flex flex-col sm:flex-row items-center lg:items-start gap-4" data-id="element-114">
              <div className="flex flex-col items-center sm:items-start gap-2" data-id="element-115">
                <a href="#comprar" onClick={e => {
                e.preventDefault();
                document.getElementById('comprar')?.scrollIntoView({
                  behavior: 'smooth'
                });
              }} className="inline-flex items-center justify-center rounded-full font-medium transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 px-8 py-4 text-lg w-full sm:w-auto bg-amber-600 hover:bg-amber-700 text-white border-none shadow-lg hover:shadow-xl hover:-translate-y-0.5" data-id="element-116">
                  Quiero 3AM RESET
                </a>
                <p className="text-sm text-slate-400" data-id="element-117">
                  <Clock className="w-4 h-4 inline mr-1" data-id="element-118" />
                  Plan de 14 noches + Guion de rescate
                </p>
              </div>
            </div>
          </div>

          {/* Product image */}
          <div className="flex-shrink-0 w-64 sm:w-72 lg:w-80" data-id="element-119">
            <div className="relative" data-id="element-120">
              <div className="absolute -inset-4 bg-amber-500/10 rounded-3xl blur-2xl" data-id="element-121"></div>
              <img src={PRODUCT_IMAGE} alt="3AM RESET — Guía práctica para volver a dormir" className="relative w-full h-auto rounded-2xl shadow-2xl shadow-black/40" data-id="element-122" />
            </div>
          </div>
        </div>
      </div>
    </div>;
}